import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-723ce057"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-wrap" }

import { withDefaults } from 'vue'
import { Field } from 'vant'


export default /*#__PURE__*/_defineComponent({
  __name: 'input-wrap-item',
  props: {
    value: null,
    placeholder: { default: '请输入' }
  },
  emits: ['update:value'],
  setup(__props: any, { emit }) {

const props = __props as { value: string, placeholder: string };




function updateValueHandle(val: string) {
  console.log('val', val)
  emit('update:value', val)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Field), {
      "model-value": props.value,
      "onUpdate:modelValue": updateValueHandle,
      placeholder: props.placeholder
    }, null, 8, ["model-value", "placeholder"])
  ]))
}
}

})